(() => {

    const CONTENT = document.querySelector('.header-desktop--content')
    const TRIGGER = document.querySelector('.ProductHolderPage-link')
    const CATEGORIES = document.querySelectorAll('.header--content-items a')

    if(!CONTENT || !TRIGGER) return

    let timeout
    const DELAY = 400
    const H = CONTENT.querySelector('.container').getBoundingClientRect().height

    // This is for development mostly
    // Set to false before pushing to production
    const PERSIST = false
    if(PERSIST) {
        CONTENT.style = `max-height: ${H}px;`
    }

    TRIGGER.addEventListener('mouseover', () => {
        clearTimeout(timeout)
        CONTENT.style = `max-height: ${H}px;`
    })

    CONTENT.addEventListener('mouseover', () => {
        clearTimeout(timeout)
    })

    if(!PERSIST) {
        TRIGGER.addEventListener('mouseout', hide)
        CONTENT.addEventListener('mouseout', hide)

        function hide() {
            timeout = setTimeout(() => {
                CONTENT.style = `max-height: 0px;`
            }, DELAY)
        }
    }

    CATEGORIES.forEach(category => {

        function toggleImage(method) {
            const className = category.getAttribute('data-image')
            const IMG = document.querySelector(`.${className}`)
            if(IMG) {
                IMG.classList[method]('show')
            }
        }

        category.addEventListener('mouseout', () => {
            toggleImage('remove')
        })
        category.addEventListener('mouseover', () => {
            toggleImage('add')
        })
    })

})()
